// src/pages/admin/components/AdminHome.js
import React from 'react';
import { Link } from 'react-router-dom';
import './AdminHome.css';

const AdminHome = ({ stats = {}, error, onRetry }) => {
  const defaultStats = {
    totalUsers: stats?.totalUsers || 0,
    totalGroups: stats?.totalGroups || 0,
    totalAssignments: stats?.totalAssignments || 0,
    activeAssignments: stats?.activeAssignments || 0
  };

  if (error) {
    return (
      <div className="admin-home error-state">
        <div className="error-container">
          <h3>Unable to load dashboard data</h3>
          <p>{error}</p>
          <button className="retry-button" onClick={onRetry}>
            Retry Loading Stats
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="admin-home">
      <div className="welcome-message">
        <h2>Admin Dashboard</h2>
        <p>Welcome to the admin dashboard. Here you can manage users, groups, and assignments.</p>
      </div>

      <div className="stats-row">
        <div className="stat-box">
          <h3>Total Users</h3>
          <div className="stat-number">{defaultStats.totalUsers}</div>
          <Link to="/admin/users" className="stat-link">Manage Users</Link>
        </div>

        <div className="stat-box">
          <h3>Learning Groups</h3>
          <div className="stat-number">{defaultStats.totalGroups}</div>
          <Link to="/admin/groups" className="stat-link">Manage Groups</Link>
        </div>

        <div className="stat-box">
          <h3>Total Assignments</h3>
          <div className="stat-number">{defaultStats.totalAssignments}</div>
          <Link to="/admin/assignments" className="stat-link">View All</Link>
        </div>

        <div className="stat-box">
          <h3>Active Assignments</h3>
          <div className="stat-number">{defaultStats.activeAssignments}</div>
          <Link to="/admin/assignments" className="stat-link">View Active</Link>
        </div>
      </div>

      <div className="dashboard-section">
        <h3>Quick Actions</h3>
        <div className="action-links">
          <Link to="/admin/users" className="action-link">
            <span className="action-icon">+</span> Add New User
          </Link>
          <Link to="/admin/groups" className="action-link">
            <span className="action-icon">+</span> Create New Group
          </Link>
          <Link to="/admin/assignments" className="action-link">
            <span className="action-icon">+</span> Create New Assignment
          </Link>
        </div>
      </div>

      <div className="dashboard-section">
        <h3>System Status</h3>
        <div className="status-info">
          <div className="status-item">
            <span className="status-label">Learning Platform:</span>
            <span className="status-value">Online</span>
          </div>
          <div className="status-item">
            <span className="status-label">Last Backup:</span>
            <span className="status-value">Today, 03:00 AM</span>
          </div>
          <div className="status-item">
            <span className="status-label">System Version:</span>
            <span className="status-value">1.0.0</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminHome;